import request from '@/utils/request'
const apiPath = '/activity/rechargeActivity'
const rechargeActivityApi = {
  /**
   * 新增【活动】
   */
  create(data) {
    return request.post(apiPath, data)
  },
  /**
   * 修改【活动】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【活动】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【活动】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【活动】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量处理上下架【活动】
   */
  updateState(data) {
    return request.post(apiPath + '/UpdateRechargeActivityState', data)
  }
}
export default rechargeActivityApi